import { render, staticRenderFns } from "./ModuleEventSuggestion.vue?vue&type=template&id=69fd9e8a&scoped=true&lang=pug&"
import script from "./ModuleEventSuggestion.vue?vue&type=script&lang=js&"
export * from "./ModuleEventSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./ModuleEventSuggestion.vue?vue&type=style&index=0&id=69fd9e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fd9e8a",
  null
  
)

export default component.exports